import React from "react";
import { Link } from "react-router-dom";
import { DAFTAR_URL } from "../../config/links";

const columns = [
    {
        title: "Platform",
        links: [
            { label: "Beranda", href: "#beranda" },
            { label: "Tentang PUSATCUAN", href: "#tentang" },
            { label: "Kategori Game", href: "#game" },
            { label: "Provider Resmi", href: "#provider" },
        ],
    },
    {
        title: "Layanan",
        links: [
            { label: "Pusatcuan Slot", href: "#game" },
            { label: "Live Casino", href: "#game" },
            { label: "Sportsbook", href: "#game" },
            { label: "Metode Transaksi", href: "#tentang" },
        ],
    },
    {
        title: "Dukungan",
        links: [
            { label: "FAQ", href: "/#faq" },
            { label: "Blog PUSATCUAN", href: "/blog", internal: true },
            { label: "Cara Deposit", href: "/blog/panduan-deposit-withdraw-pusatcuan", internal: true },
            { label: "Daftar Sekarang", href: DAFTAR_URL, external: true },
        ],
    },
];

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="relative border-t border-white/5 bg-[#050505]"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-24">
                <div className="grid lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-5">
                        <div className="text-5xl md:text-7xl font-semibold tracking-tighter text-gold-gradient">
                            PUSATCUAN
                        </div>
                        <p className="mt-6 text-white/60 max-w-md leading-relaxed">
                            Platform hiburan digital terbaik & link resmi terpercaya.
                            Situs hiburan online terpercaya dengan akses game online
                            terbaru 24 jam nonstop.
                        </p>
                        <div className="mt-8 flex gap-3">
                            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-[#D4AF37]/30 text-[11px] tracking-[0.2em] uppercase text-[#D4AF37]">
                                18+ Only
                            </span>
                            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/10 text-[11px] tracking-[0.2em] uppercase text-white/60">
                                Bermain Bertanggung Jawab
                            </span>
                        </div>
                    </div>

                    <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-8">
                        {columns.map((col) => (
                            <div key={col.title}>
                                <div className="text-xs tracking-[0.25em] uppercase text-[#D4AF37]">
                                    {col.title}
                                </div>
                                <ul className="mt-5 space-y-3">
                                    {col.links.map((l) => {
                                        const testId = `footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`;
                                        const cls = "text-sm text-white/70 hover:text-[#D4AF37] transition-colors";
                                        if (l.external) {
                                            return (
                                                <li key={l.label}>
                                                    <a data-testid={testId} href={l.href} target="_blank" rel="noopener noreferrer" className={cls}>
                                                        {l.label}
                                                    </a>
                                                </li>
                                            );
                                        }
                                        if (l.internal) {
                                            return (
                                                <li key={l.label}>
                                                    <Link data-testid={testId} to={l.href} className={cls}>
                                                        {l.label}
                                                    </Link>
                                                </li>
                                            );
                                        }
                                        return (
                                            <li key={l.label}>
                                                <a data-testid={testId} href={l.href} className={cls}>
                                                    {l.label}
                                                </a>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                    <p className="text-xs text-white/40">
                        © {new Date().getFullYear()} PUSATCUAN. Platform hiburan digital
                        terbaik di Indonesia. All rights reserved.
                    </p>
                    <p className="text-[11px] text-white/30 max-w-xl">
                        Konten di situs ini hanya ditujukan untuk pengguna berusia 18
                        tahun ke atas. Selalu bermain dengan bertanggung jawab.
                    </p>
                </div>
            </div>
        </footer>
    );
}
